
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Close, FileCopySharp } from '@material-ui/icons';
import { onlyInteger } from 'hooks/Pipe';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'ID Compra', accessor: 'purch_purchase_id', width: 120 },
  { Header: 'Código producto', accessor: 'ItemCode', width: 160 },
  { Header: 'Nombre producto', accessor: 'ItemName'},
  { Header: 'Usuario', accessor: 'usuario', width: 300},
  { Header: 'Cantidad orden', accessor: 'quantity_po', width: 150 },
  { Header: 'Cantidad compra', accessor: 'quantity_p', width: 165 },
  { Header: 'Comentario', accessor: 'comment' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  const { id, showNotify, oCDiferencia, setOCDiferencia, oCDetails, reload, ordenCompra } = props;

  const handleChange = (id, field, value) => {
    const index = oCDiferencia.findIndex((item) => item.id == id);
    oCDiferencia[index][field] = value;
    setOCDiferencia([...oCDiferencia]);
  };

  async function updatePurchOrderDetail(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('purch/purchase-order-diferencia', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      reload();
    } else {
      reload();
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de diferencias para orden de compra
          <span style={{ fontSize: '14px' }}>
            <b>{` (${ordenCompra.CardName || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            exportExcel={false}
            formatDate="DD-MM-YYYY"
            columns={columns}
            colorRow={(item) => {
              let color = '';
              if (item.quantity_po === 'Sin compra') {
                color = '';  
              } else if (item.quantity_p < item.quantity_po) {
                color = '#ff00001f';
              } else if (item.quantity_p > item.quantity_po) {
                color = '#00d11a45';
              }
              return color;
            }}
            data={oCDiferencia.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                  </div>
                ),
                purch_purchase_id: item.purch_purchase_id,
                ItemCode: item.ItemCode,
                ItemName: item.ItemName,
                usuario: item.usuario,
                quantity_po: item.quantity_po || 'Sin compra',
                quantity_p: item.quantity_p,
                comment: (
                  <AllowedGuard
                    permission={ConstantPermissions.PURCH_PURCHASES_UPDATE}
                    component={item.comment}
                  >
                    <TextField
                      fullWidth
                      type="text"
                      name="comment"
                      margin="normal"
                      disabled={ordenCompra.state !== 'S' && ordenCompra.state !== 'R'}
                      value={item.comment || ''}
                      onChange={(e) => handleChange(item.id, 'comment', e.target.value)}
                      onBlur={(e) => updatePurchOrderDetail(item.id, 'comment', e.target.value)}
                    />
                  </AllowedGuard>
                ),
                modification: (
                  <AllowedGuard
                    permission={ConstantPermissions.PURCH_PURCHASES_UPDATE}
                    component={item.modification}
                  >
                    <TextField
                      fullWidth
                      type="text"
                      name="modification"
                      margin="normal"
                      disabled={ordenCompra.state !== 'S' && ordenCompra.state !== 'R'}
                      value={item.modification || ''}
                      onChange={(e) => handleChange(item.id, 'modification', e.target.value)}
                      onBlur={(e) => updatePurchOrderDetail(item.id, 'modification', e.target.value)}
                    />
                  </AllowedGuard>
                ),
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
